import { CanActivateFn, Router } from '@angular/router';
import { UserLogin } from '../models/user.login';
import { inject } from '@angular/core';
import { LoginService } from '../services/login.service';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  let IsAuthorized : boolean = false;
  let expectedRoleArray = route.data["expectedRole"];
  let userEmail = localStorage.getItem('UserEmail');
  let selectedVendor = localStorage.getItem('selectedVendor');
  if(userEmail != null && selectedVendor != null){
    let userRoleInfo = localStorage.getItem('UserRoleInfo');
    if (userRoleInfo != null) {
      let decodedUserRoleInfo : UserLogin = JSON.parse(atob(userRoleInfo));      
      IsAuthorized = decodedUserRoleInfo.roles.some((a:any)=> expectedRoleArray.includes(a.roleKey));
    }
  }
  if(!IsAuthorized)
  {
    return router.navigate(['login']);
  }
  return IsAuthorized;
}
